import { render, staticRenderFns } from "./AddPurchaseOrder.vue?vue&type=template&id=6b158930&scoped=true&"
import script from "./AddPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchaseOrder.vue?vue&type=style&index=0&id=6b158930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b158930",
  null
  
)

export default component.exports